window.clock = function() {
    const dateFormat = window.date_format || 'd-m-Y';
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    if (month < 10) {
        month = "0" + month;
    }
    let day = today.getDate();
    if (day < 10) {
        day = "0" + day;
    }
    switch (dateFormat){
        case 'd-m-Y':
            var date = day + "-" + month + "-" + year;
            break;
        case 'Y-m-d':
            var date = year + "-" + month + "-" + day;
            break;
    }
    let hours = today.getHours();
    let minutes = today.getMinutes();
    let seconds = today.getSeconds();
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    let el = document.getElementById('clock');
    if (typeof el !== "undefined" && el !== null) {
        el.innerHTML = date + " " + hours + ":" + minutes + ":" + seconds;
        setTimeout(clock, 500);
    }
};
